"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormTextFieldMultiple = void 0;
const form_field_1 = require("./form-field");
const text_field_multiple_1 = require("../../../components/text-field/multiple/text-field-multiple");
exports.FormTextFieldMultiple = form_field_1.formFieldFactory(text_field_multiple_1.TextFieldMultiple);
//# sourceMappingURL=form-text-field-multiple.js.map